module.exports = __webpack_public_path__ + "static/media/harp-arpeggio.aea148ba.mp3";